import React from 'react'
import { useRouteMatch, Link, useLocation, useHistory } from 'react-router-dom'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Button from '@material-ui/core/Button'
import Badge from '@mui/material/Badge'
import { PageHeader } from 'components/page-header'
import LeadsQuery from './leads-query'
import { useGetLeads } from './api-hooks'
import { ReactComponent as AutoRespondersIcon } from 'images/icons/auto-responders.svg'

const LeadsPage = React.memo(({ setUnviewedLeadCount }) => {
  const { path } = useRouteMatch()
  const location = useLocation()
  const history = useHistory()

  const {
    loading: leadsLoading,
    error: leadsError,
    data: leadsData,
    refetch: leadsRefetch,
  } = useGetLeads()

  const unviewedLeadsCount =
    leadsData &&
    leadsData.coachingInquiries?.filter(lead => lead.viewedAt === null).length
  const queryParams = new URLSearchParams(location.search)
  const isLeadsContactedPage = queryParams.get('tab') === 'contacted'

  const tabs = (
    <Tabs value={isLeadsContactedPage ? 'contacted' : 'new'}>
      <Badge
        color="error"
        badgeContent={unviewedLeadsCount}
        invisible={unviewedLeadsCount === 0}
        value="new"
        sx={theme => ({
          '& .MuiBadge-badge': {
            right: '3rem',
            transform: 'unset',
            backgroundColor: '#f44336',
            [theme.breakpoints.only('xs')]: {
              right: 0,
            },
          },
        })}
      >
        <Tab label="New" value="new" component={Link} to={`${path}?tab=new`} />
      </Badge>
      <Tab
        label="Contacted"
        value="contacted"
        component={Link}
        to={`${path}?tab=contacted`}
      />
    </Tabs>
  )

  const actions = (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<AutoRespondersIcon style={{ width: 20, height: 20 }} />}
      onClick={() => history.push('/pga-coach/settings/leads-auto-reply')}
    >
      Lead Auto-Reply
    </Button>
  )

  return (
    <>
      <PageHeader
        title="Leads"
        tabs={tabs}
        actions={actions}
        fixedMobileActions
      />
      <LeadsQuery
        {...{
          data: leadsData?.coachingInquiries,
          coachingLeadContactMethodOptions:
            leadsData?.coachingLeadContactMethodOptions ?? [],
          freeTierLimitsReached:
            leadsData?.currentUser?.attributes?.freeTierLimitsReached,
          error: leadsError,
          loading: leadsLoading,
          refetch: leadsRefetch,
          setUnviewedLeadCount,
          tab: isLeadsContactedPage ? 'contacted' : 'new',
        }}
      />
    </>
  )
})

export default LeadsPage
